import { Typography } from 'antd'
import React from 'react'

function UIAntText({ children, ...props }) {
    return <Typography.Text {...props}> {children} </Typography.Text>
}

export default UIAntText
